import { useEffect } from "react";

const SITE_TITLE = "On Point Combat";
const SITE_URL = "https://onpointcombat.xyz/";
const SITE_DESCRIPTION = "Mixed Martial Arts (MMA), Boxing, Wrestling, News, Live Scorecard, Rankings";

const EMPTY_ARTICLES = [];

const setMeta = (name, content, property = false) => {
  const attribute = property ? "property" : "name";
  let element = document.querySelector(`meta[${attribute}="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const removeMeta = (name, property = false) => {
  const attribute = property ? "property" : "name";
  document.querySelector(`meta[${attribute}="${name}"]`)?.remove();
};

const useNews = (articles = EMPTY_ARTICLES) => {
  useEffect(() => {
    document.title = SITE_TITLE;
    setMeta("description", SITE_DESCRIPTION);
    setMeta("og:title", SITE_TITLE, true);
    setMeta("og:description", SITE_DESCRIPTION, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", SITE_URL, true);
    setMeta("twitter:card", "summary_large_image");
    removeMeta("og:image", true);
  }, []);

  useEffect(() => {
    if (!articles.length) return;

    const schema = document.createElement("script");
    schema.id = "blog-schema";
    schema.type = "application/ld+json";

    schema.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: SITE_TITLE,
      url: SITE_URL,
      hasPart: articles.slice(0, 10).map((article) => ({
        "@type": "NewsArticle",
        headline: article.title,
        url: `${SITE_URL}/blog/${article.slug}`,
        datePublished: article.publishedAt,
        ...(article.author && {
          author: { "@type": "Person", name: article.author },
        }),
        ...(article.publisher && {
          publisher: { "@type": "Organization", name: article.publisher },
        }),
      })),
    });

    document.head.appendChild(schema);

    return () => schema.remove();
  }, [articles]);
};

export default useNews;